import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import './styles.css';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';
import'../../assests/arrow-left-solid.svg';
import { useTranslation } from 'react-i18next';

export default function ListaPlanos() {
    const history = useHistory();
    const BASE_URL = 'https://agrobrazilapp.com/';
    const USER_EMAIL = sessionStorage.getItem('email');
    const USER_TOKEN = sessionStorage.getItem('token');
    const [planData, setPlanData] = useState([]);
    const { t } = useTranslation();

    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN);
    data.append('USER_EMAIL', USER_EMAIL);

    const axios = require('axios');
    useEffect(() => {
        api.get(`${BASE_URL}/v4/plans`, {
            headers: {
                'USER_EMAIL': USER_EMAIL,
                'USER_TOKEN': USER_TOKEN,
            }
        }).then(response => {

        }).catch(err => {
            if (err.status === 401) {
                history.push('/');
            }
        });

        var config = {
            method: 'get',
            url: ` ${BASE_URL}/v4/plans`,
            headers: {
                'Content-Type': 'application/json',
                'USER_TOKEN': USER_TOKEN,
                'USER_EMAIL': USER_EMAIL
            }
        };

        axios(config)
            .then(function (response) {
                setPlanData(response.data.filter(function(e){ return e.platform === "iugu" }));



            })
            .catch(function (error) {
                console.log(error);
            });



    }, [USER_EMAIL, USER_TOKEN, history]);

const getPlan = (id, plan)=>{
    var check = false;
    const radio= document.getElementById(id);
    const selectedPlan= JSON.stringify(plan);
    if(radio.checked){
        check=true;
       sessionStorage.setItem('selectedPlan',selectedPlan);

    }

}

    return (
        <>
            <div className="Checkout-container">
                <Header />
                <button class ="btn-voltar" onClick={()=>{history.go(-1)}}> <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14 arrumaArrow" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path></svg></button> <div class="titulopagina"><TituloPagina titulo={t('pages.listPlans.title')} /></div>
                <section className="bodyplan">
                    <div className="conteudo">
                        <div className="Checkout/Plano">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        < ul class="listaplanos">
                                            <div >
                                            <form id="selectedPlan"  action="/checkout/metodo-pagamento">
                                                {
                                                    planData.map(plan => (

                                                        <div>

                                                            <div class="plandiv">

                                                                <li key={plan.iugu_id}>
                                                                    <label >

                                                                    <input required
                                                                        type="radio"
                                                                        id={plan.iugu_id}
                                                                        onClick={()=>{
                                                                            getPlan(plan.iugu_id, plan);
                                                                        }}
                                                                        name="plan" value={plan.name}
                                                                        className="planradiobutton"
                                                                    ></input> 
                                                                    <p>{plan.name}</p>
                                                                    <p>{plan.description}</p>
                                                                    <p>{plan.price}</p>
                                                                    </label> 


                                                                </li>

                                                            </div>


                                                        </div>

                                                    )

                                                    )

                                                }
                                                    <button id="plano/pagamento"
                                                    className="btn-payment" 
                                                    ><span > {t('commons.buttons.next')} </span></button>
                                                    </form>
                                            </div>

                                        </ul>

                                    </div>

                                </div>
                            </div>
                            </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    );
}
